module.exports = __webpack_public_path__ + "img/tra-ket-qua-icon.a604dd37.svg";